export default {
  'client.host_details.validation_results.client_status.header':
    'Client Health Check'
}
